// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1lZIc","footer__link":"footer_footer__link__16Kx5","footer__text":"footer_footer__text__g-OYd"};